export const threatIntelInitialState = {
    view : {
        list: ['list', 'grid'],
        currentView: 'list',
        default: 'list',
    },
    events : [],
    eventsLoading: false,
    filters: "dtcTime|last30d",
    sorting : "dtcTime|desc",
    pageNo : 1,
    pageSize: 21,
    displaySize: 20,
    isLastPage: false,
    resetOnChange: true,
    screenshots: {},
    screenshotsLoading: {},
    selectedEvent: {},
    selectedEventLoading: false,
    unverify: false,
    unverifyLoading: false,
    verifyStatusCode: null,
}